module.exports = __webpack_public_path__ + "fonts/95b573c6a0dc5c595f96c41310953313.svg";